export default __webpack_public_path__ + "static/media/hacker-news.77ff86c1.png";